import { render, staticRenderFns } from "./AppLink.vue?vue&type=template&id=2518ee59&scoped=true&lang=pug&"
import script from "./AppLink.vue?vue&type=script&lang=ts&"
export * from "./AppLink.vue?vue&type=script&lang=ts&"
import style0 from "./AppLink.vue?vue&type=style&index=0&id=2518ee59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2518ee59",
  null
  
)

export default component.exports